module.exports = __webpack_public_path__ + "img/手机双指缩放.3b9d116b.png";